module.exports = __webpack_public_path__ + "img/icon-question-delete-hover.ec2e4e8f.svg";